import { call, put, select, takeLatest } from "redux-saga/effects";
import {
    sendMessage,
    sendMessageSuccess,
    sendMessageFailure,
    selectChatMessages,
} from '../reducers/chatReducer';
// import { postChatMessage } from "./chatApi";

// How many prior turns to send back to the LLM. Keep this bounded so
// long conversations don't blow the context window / cost budget.
const MAX_HISTORY_TURNS = 20;

function* handleSendMessage(action) {
    const { message } = action.payload;

    try {
        const allMessages = yield select(selectChatMessages);

        // Trim + reshape into the {role, content} pairs the LLM API expects.
        // (allMessages already includes the just-added user message from the
        // reducer, so slice it off before sending as "history".)
        const history = allMessages
            .slice(0, -1)
            .slice(-MAX_HISTORY_TURNS)
            .map(({ role, content }) => ({ role, content }));

        // const data = yield call(postChatMessage, message, history);
        const data = { reply: `Echo: ${message}` };
        yield put(sendMessageSuccess({ reply: data.reply }));
    } catch (err) {
        const detail =
            err?.errors?.[0]?.detail || err?.message || "Something went wrong. Please try again.";
        yield put(sendMessageFailure({ detail }));
    }
}

export function* chatSaga() {
    yield takeLatest(sendMessage.type, handleSendMessage);
}